import {defineStyle, defineStyleConfig} from '@chakra-ui/styled-system';
import {cssVar} from '@chakra-ui/theme-tools';

// Links for @chakra-ui/theme@3.3.0

// Theme source
// @link https://github.com/chakra-ui/chakra-ui/blob/%40chakra-ui/theme%403.3.0/packages/components/theme/src/components/tooltip.ts

// Component source
// @link https://github.com/chakra-ui/chakra-ui/blob/%40chakra-ui/theme%403.3.0/packages/components/tooltip/src/tooltip.tsx

// Design
// https://www.figma.com/file/fUp4qrVCn5nngJirY3KJ6z/Aligned-Design-System?type=design&node-id=714-10834&mode=design&t=sxjsjY05ilWTzJ5H-0

const $bg = cssVar(`tooltip-bg`);
const $fg = cssVar(`tooltip-fg`);

const baseStyle = defineStyle({
  [$bg.variable]: `black`,
  [$fg.variable]: `white`,
  _dark: {
    [$bg.variable]: `white`,
    [$fg.variable]: `black`,
  },
  p: `space-200`,
  borderRadius: `radius-150`,
  fontWeight: `400`,
  fontSize: `sm`,
  lineHeight: `1.5rem`,
  boxShadow: `none`,
});

export const tooltipTheme = defineStyleConfig({
  baseStyle,
});
